import React, { PropTypes } from 'react';
import PureComponent from 'components/PureComponent';

class Pattern extends PureComponent {
  static propTypes = {
    children: PropTypes.any,
    left: PropTypes.string.isRequired,
    colorLeft: PropTypes.string,
    colorRight: PropTypes.string
  };

  static defaultProps = {
    left: '50%',
    top: '50%',
    colorLeft: 'rgba(0,77,176,0.35)',
    colorRight: 'rgba(0,77,176,0.35)'
  };

  render() {
    require('./Pattern.styl');
    return (
      <div className="Pattern">
        <div
          className="Pattern__part"
          style={{
            left: this.props.left,
            top: this.props.top,
            backgroundColor: this.props.colorLeft
          }}
        />
        <div
          className="Pattern__part"
          style={{
            left: this.props.left,
            top: this.props.top,
            backgroundColor: this.props.colorRight
          }}
        />

        {this.props.children}
      </div>
    );
  }
}

export default Pattern;



// WEBPACK FOOTER //
// ./src/components/Pattern/Pattern.js